(() => {
  const template = document.getElementById('DopeApprovalStoryTemplate');
  const root = document.getElementById('MainContent');
  if (!template || !root || root.dataset.approvalStoryConnected) return;
  root.dataset.approvalStoryConnected = 'true';

  // Match visible copy, including phrases split across inline markup. Do not
  // modify merchant HTML, links, structured data, forms, or machine endpoints.
  const notice = /\b(?:not|never|isn['’]t|aren['’]t)\s+(?:currently\s+)?(?:listed\s+as\s+)?(?:usa(?:\s+pickleball)?|usapa?)[\s-]+approved\b|\bnot\s+approved\s+by\s+(?:usa(?:\s+pickleball)?|usapa?)\b/i;
  const blocks = 'p,li,dd,dt,td,th,h1,h2,h3,h4,h5,h6,figcaption,blockquote,div';
  const excluded = 'script,style,template,noscript,textarea,select,button,summary,svg,pre,code,[aria-hidden="true"],[data-dope-approval-story]';
  const automatic = new Map();

  function textOf(block) {
    const walker = document.createTreeWalker(block, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        return node.parentElement.closest(excluded) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      },
    });
    let text = '';
    while (walker.nextNode()) text += walker.currentNode.textContent;
    return text.replace(/\s+/g, ' ').trim();
  }

  function refresh() {
    observer.disconnect();
    for (const [block, disclosure] of automatic) {
      if (!root.contains(block) || !root.contains(disclosure) || block.closest(excluded) || !notice.test(textOf(block))) {
        disclosure.remove();
        automatic.delete(block);
      }
    }

    const candidates = new Set();
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const parent = walker.currentNode.parentElement;
      if (!parent || parent.closest(excluded)) continue;
      const block = parent.closest(blocks);
      if (block && root.contains(block)) candidates.add(block);
    }

    for (const block of candidates) {
      if (automatic.has(block) || !notice.test(textOf(block))) continue;
      // A container must not duplicate disclosures for its child paragraphs.
      if ([...block.querySelectorAll(blocks)].some(child => notice.test(textOf(child)))) continue;
      if (block.nextElementSibling?.matches('[data-dope-approval-story]')) continue;

      // A card may wrap its text in a link. Keep the disclosure outside it.
      const anchor = block.closest('a') || block;
      const inside = anchor === block && block.matches('li,dd,dt,td,th');
      if (inside && block.querySelector(':scope > [data-dope-approval-story]')) continue;
      if (!inside && anchor.nextElementSibling?.matches('[data-dope-approval-story]')) continue;
      const disclosure = template.content.firstElementChild.cloneNode(true);
      if (inside) block.append(disclosure);
      else anchor.after(disclosure);
      automatic.set(block, disclosure);
    }
    observer.observe(root, { childList: true, subtree: true, characterData: true });
  }

  let scheduled = false;
  const observer = new MutationObserver(records => {
    if (records.every(record => record.target.parentElement?.closest('[data-dope-approval-story]'))) return;
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; refresh(); });
  });
  refresh();
})();
